import React, { useState } from "react";
import { AppLogo } from "../assets/images";
import { AppColors } from "../assets/Colors";

const Header = ({ scrollToSection }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: AppColors.white,
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
        minHeight: "90px",
        padding: "0 20px",
        position: "relative",
      }}
    >
      {/* Left side - Logo */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={AppLogo}
          alt="Web Logo"
          style={{ height: "120px", width: "200px", objectFit: "contain" }}
        />
      </div>

      {/* Center Nav Links (hidden on mobile) */}
      <div
        style={{
          display: "flex",
          gap: "50px",
          fontWeight: "500",
          fontSize: "20px",
          color: "#000",
          cursor: "pointer",
        }}
        className="desktop-menu"
      >
        <span onClick={() => scrollToSection("modules")}>Modules</span>
        <span onClick={() => scrollToSection("earlyDetection")}>
          Early Detection
        </span>
        <span onClick={() => scrollToSection("supportGroups")}>
          Support Groups
        </span>
        <span onClick={() => scrollToSection("privacyPolicy")}>
          Privacy Policy
        </span>
        <span onClick={() => scrollToSection("doctorDashboard")}>
          Doctor Dashboard
        </span>
      </div>

      {/* Right side - Button (always visible) */}
      <div
        style={{
          backgroundColor: "#ffb6c1",
          padding: "10px 20px",
          borderRadius: "50px",
          fontWeight: "700",
          fontSize: "14px",
          cursor: "pointer",
          whiteSpace: "nowrap",
          color: "#000",
        }}
      >
        START SELF ASSISMENT
      </div>

      {/* Hamburger Icon (mobile only) */}
      <div
        className="mobile-menu-icon"
        style={{
          display: "none",
          flexDirection: "column",
          gap: "5px",
          cursor: "pointer",
          marginLeft: "10px",
        }}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <div style={{ width: "25px", height: "3px", background: "#000" }} />
        <div style={{ width: "25px", height: "3px", background: "#000" }} />
        <div style={{ width: "25px", height: "3px", background: "#000" }} />
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div
          style={{
            position: "absolute",
            top: "90px",
            right: "20px",
            background: "#fff",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            borderRadius: "10px",
            padding: "15px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            zIndex: 1000,
          }}
          className="mobile-menu"
        >
          <span onClick={() => scrollToSection("modules")}>Modules</span>
          <span onClick={() => scrollToSection("earlyDetection")}>
            Early Detection
          </span>
          <span onClick={() => scrollToSection("supportGroups")}>
            Support Groups
          </span>
          <span onClick={() => scrollToSection("privacyPolicy")}>
            Privacy Policy
          </span>
          <span onClick={() => scrollToSection("doctorDashboard")}>
            Doctor Dashboard
          </span>
        </div>
      )}

      {/* Responsive CSS */}
      <style>
        {`
          @media (max-width: 768px) {
            .desktop-menu {
              display: none !important;
            }
            .mobile-menu-icon {
              display: flex !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Header;
